<template>
	<div>
		<page-head></page-head>
		<empty v-if="networkError" type="network" height="600px"></empty>
		<slot v-else></slot>
		<page-foot></page-foot>
	</div>
</template>

<script>
	import empty from '@/components/public/empty.vue'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			empty
		},
		
		computed: {
			...mapState(['networkError'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>
